"use strict";

var React = require('react/addons'),
    ReactRouter = require('react-router'),
    DocumentTitle = require('react-document-title'),
    cx = require('classnames'),
    BS = require('react-bootstrap'),
    Constants = require('../../constants'),
    ToolboxSidebar = require('./Sidebar'),
    Header = require('./Header'),
    Footer = require('./Footer'),
    CurrentUser = require('../../shared/CurrentUser'),
    BrochureTemplates = require('../../collections/BrochureTemplates'),
    Link = require('../../components/Link');

var ToolboxPersonalizedBrochure = React.createClass({displayName: "ToolboxPersonalizedBrochure",

    contextTypes: {
        router: React.PropTypes.func
    },

    getInitialState: function() {
        return {
            showPreview: false
        };
    },

    getDefaultProps: function() {
        return {
            collection: new BrochureTemplates()
        };
    },

    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            data = props.project.toJSON(),
            query = {
                API: me.context.router.getCurrentQuery().API
            },
            url = Constants.restPath + '/agents/brochure?format=pdf&template=basic&listingId=26761',
            title = props.title + ' - Personalized Brochure';

        return (
             React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                React.createElement(Header, {project: props.project, builder: props.builder}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement(ToolboxSidebar, {project: props.project, showContactForm: true}), 
                        React.createElement("div", {className: "col-sm-9"}, 
                            React.createElement("div", {className: "margin-bottom-20"}, 
                                React.createElement("h1", null, "Agent Branded Brochures"), 
                                React.createElement("p", null, "Agent Branded Brochures are designed agents with personalized marketing materials. The pre-created brochures contain information about the community and branded for the agent's information. Agents can download the brochures to give to their buyers.")
                            ), 
                            React.createElement("div", null, 
                                React.createElement("ul", {className: "inline-list"}, 
                                    props.collection.map(function(model) {
                                        return (
                                            React.createElement("li", {key: model.id, className: "margin-bottom-10"}, 
                                                React.createElement("h5", null, model.get('name')), 
                                                React.createElement("a", {href: "#", onClick: me.onPreview.bind(null, model), alt: "Preview Brochure", title: "Preview Brochure"}, 
                                                    React.createElement("img", {className: "margin-bottom-10", src: model.get('image')})
                                                ), 
                                                React.createElement("br", null), 
                                                React.createElement("a", {href: model.getPreviewURL({ listingId: props.project.id }), target: "_blank", className: "pull-right btn-u btn-u-ultra-narrow btn-u-orange"}, "Download")
                                            )
                                        );
                                    })
                                )
                            )
                        )
                    ), 
                    React.createElement(Footer, {trackerId: "agent-toolbox-personalized-brochure"})
                ), 
                React.createElement(BS.Modal, {className: "modal-preview modal-lg", show: state.showPreview, onHide: this.closePreviewDialog}, 
                    React.createElement(BS.Modal.Body, {className: "padding-0"}, 
                        React.createElement("iframe", {style: { width: '100%', height: '1055px', border: 0}, src: state.previewURL})
                    )
                )
            )
        );
    },

    onPreview: function(model, e) {
        var me = this;
        if(e && e.preventDefault) {
            e.preventDefault();
        }
        me.setState({
            showPreview: true,
            previewURL: model.getPreviewURL({ listingId: me.props.project.id, format: 'pdf-preview' })
        });
    },

    closePreviewDialog: function() {
        this.setState({
            showPreview: false,
            previewURL: undefined
        });
    }
});
module.exports = ToolboxPersonalizedBrochure;
